module.exports = __webpack_public_path__ + "static/media/natural.4a31a957.svg";